import { mapState } from 'vuex'

export const authorityMixin = {
  computed: {
    ...mapState({
      loginUser: state => state.auth.loginUser,
      token: state => state.auth.token
    })
  }
}
export const tableReqArgMixin = {
  computed: mapState(['planId', 'adId', 'groupId', 'ownerIds'])
}

export const tableData = {
  data () {
    return {
      dataSource: []
    }
  },
  created () {
    this.dataSource = this.tableData
  },
  props: ['tableData'],
  watch: {
    tableData (val) {
      this.dataSource = [...val]
    }
  },
  methods: {
    // 根据tabKey来请求table数据并改变vuex的proTable,table组件数据源自动更新
    async fetchTable (key) {
      let res = ''
      switch (String(key)) {
        case '0':
          break
        case '1':
          break
        case '2':
          break
        case '3':
          break
      }

      if (res && Array.isArray(res)) {
        res.forEach((item, index) => {
          item.key = index
        })
        this.$store.dispatch('updateProTable', res)
        return res
      }
    },
    isSearchId (value) {
      let reg = /^[0-9]*$/
      let val = value.trim()
      return !isNaN(val) && reg.test(val) && val !== ''
    }
  }
}
